module.exports = __webpack_public_path__ + "css/dark.51961f07.css";